import * as vp from 'vopay';
import { formattedCurrency } from 'vopay';

type AccountTransferRows = {
  label: vp.AccountTransferLabel;
  id: vp.AccountTransferId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'input' | 'select';
  placeholder: string;

  getSelectOptions: () => { [key: string]: string };
};

type AccountTranferRowsProp = {
  AccountID: string;
  Currency: string;
  MainAccountName: string;
  MainAccountId: string;
  MainAccountBalance: string;
  subAccounts: Record<string, vp.SubAccountsLists>;
  country: string;
};

export const buildAccountTransferRows = ({
  AccountID,
  Currency,
  MainAccountName,
  MainAccountBalance,
  MainAccountId,
  subAccounts,
  country,
}: AccountTranferRowsProp): AccountTransferRows[] => {
  const CurrencyOptions = {
    ...vp.CURRENCY_LIST_OPTIONS,
  };
  const FromBankAccountsOptions = buildSubAccountOptions(
    Object.values(subAccounts).filter((data) => data.AccountStatus === 'Active'),
    Currency,
    false,
  );
  const ToBankAccountsOptions = buildSubAccountOptions(
    Object.values(subAccounts).filter((data) => AccountID !== data.AccountID && data.AccountStatus === 'Active'),
    Currency,
    AccountID === MainAccountId,
  );
  return [
    {
      label: vp.AccountTransferLabel.Currency,
      id: vp.AccountTransferId.Currency,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: '',
      getSelectOptions: () => (country === 'US' ? vp.US_CURRENCY_ONLY : CurrencyOptions),
    },
    {
      label: vp.AccountTransferLabel.From,
      id: vp.AccountTransferId.From,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: 'Please Select...',
      getSelectOptions: () => FromBankAccountsOptions,
    },
    {
      label: vp.AccountTransferLabel.To,
      id: vp.AccountTransferId.To,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: 'Please Select...',
      getSelectOptions: () => ToBankAccountsOptions,
    },
    {
      label: vp.AccountTransferLabel.Amount,
      id: vp.AccountTransferId.Amount,
      require: true,
      preset: 'currency',
      type: 'input',
      placeholder: '0.00',
      getSelectOptions: () => ({}),
    },
  ];

  function buildSubAccountOptions(lists: vp.SubAccountsLists[], currencySelected: string, removeMain: boolean) {
    const inital = removeMain
      ? {}
      : { [MainAccountId]: `${MainAccountName} ($${formattedCurrency(MainAccountBalance) || '0.00'})` };
    return lists
      .sort((a, b) => {
        const nameA = a.AccountName.toUpperCase(); // Convert name to uppercase for case-insensitive sorting
        const nameB = b.AccountName.toUpperCase();

        if (nameA < nameB) {
          return -1; // a should be before b
        }
        if (nameA > nameB) {
          return 1; // a should be after b
        }

        return 0; // a and b are equal
      })
      .reduce(
        (accumulator, data) => ({
          ...accumulator,
          [data.AccountID]: `${data.AccountName} ($${formattedCurrency(
            Object.values(data.Balances).filter((balances) => balances.Currency === currencySelected)[0]
              ?.AvailableBalance || '0.00',
          )}  
          )`,
        }),
        inital,
      );
  }
};
